import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { PopupService } from '../../shared/modal/popup.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { AlertService } from '../../shared/alert/alert.service';
import { JhiEventManager } from '../../shared/core-utils';
import { LotService } from '../../shared/inventory/service/lot.service';
import { SubscriptionsManager } from '../../shared/util/subscriptions-manager';

@Component({
    selector: 'jhi-lot-split-dialog',
    templateUrl: './lot-split-dialog.component.html'
})
export class LotSplitDialogComponent implements OnInit, OnDestroy {

    splitLotUUIDs: string[];
    lot: NewLotModel;
    model;
    deposit: InitialDepositModel;
    initialDeposit = true;
    storageLocationId;
    subscriptionsManager = new SubscriptionsManager();

    constructor(private activatedRoute: ActivatedRoute,
                private alertService: AlertService,
                public activeModal: NgbActiveModal,
                private lotService: LotService,
                private eventManager: JhiEventManager
    ) {
        this.subscriptionsManager.add = this.activatedRoute.queryParams.subscribe((params) => {
            this.splitLotUUIDs = params.selectedItem;
        });

        this.model = { stockIdPrefix: '' };
        this.lot = new NewLotModel();
        this.deposit = new InitialDepositModel();
    }

    ngOnDestroy(): void {
        this.subscriptionsManager.unsubscribeAll();
    }

    ngOnInit() {
    }

    clear() {
        this.activeModal.dismiss('cancel');
    }

    save() {
        this.lot.locationId = this.storageLocationId;
        this.lot.generateStock = true;
        this.lot.stockPrefix = this.model.stockIdPrefix;

        const lotSplitRequestDto = {
            newLot: this.lot,
            initialDeposit: this.deposit,
            selectedLots: { itemIds: this.splitLotUUIDs }
        };
        this.subscriptionsManager.add = this.lotService.splitLot(lotSplitRequestDto).subscribe(
            (res) => this.onSaveSuccess(res));
    }

    isInvalid() {
        return isNaN(this.storageLocationId);
    }

    private onSaveSuccess(result: any) {
        this.alertService.success('inventoryManagerApp.lot.split.success');
        this.eventManager.broadcast({ name: 'columnFiltersChanged', content: 'OK' });
        this.activeModal.dismiss(result);
    }

    checkInitialDeposit($event) {
        $event.srcElement.checked = true;
    }
}

@Component({
    selector: 'jhi-lot-deposit-popup',
    template: ''
})
export class LotSplitPopupComponent implements OnInit, OnDestroy {

    routeSub: any;

    constructor(
        private route: ActivatedRoute,
        private popupService: PopupService
    ) {
    }

    ngOnInit() {
        this.routeSub = this.route.params.subscribe(() => {
            this.popupService.open(LotSplitDialogComponent as Component);
        });
    }

    ngOnDestroy() {
        this.routeSub.unsubscribe();
    }
}

class NewLotModel {
    constructor(
        public generateStock?: boolean,
        public notes?: string,
        public locationId?: number,
        public stockPrefix?: string
    ) {
    }
}

class InitialDepositModel {
    constructor(
        public amount?: number,
        public notes?: string
    ) {
    }
}
